export default __webpack_public_path__ + "static/media/fileUpload.da35fbbd.svg";